import React from "react";
import MenuComponent from "../../components/MenuComponent/MenuComponent";
import Select from "react-select";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import EditLogo from "../../Assets/editLogo.png";
import PdfLogo from "../../Assets/pdf-icon.png";
import DeleteIcon from "../../Assets/delete_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import { formatDot } from "../../util/helperFunction";
import "./PurchaseOrder.css";
import { usePurchaseOrder } from "./usePurchaseOrder";
import PdfPurchaseOrder from "../../components/PdfPurchaseOrder/PdfPurchaseOrder";
import { pdf } from "@react-pdf/renderer";
import { bulan, tahun } from "../../util/constant";
import moment from "moment";

const PurchaseOrder = () => {
  const {
    menu,
    setMenu,
    dataUser,
    popUpBuatPo,
    handleCloseBuatPo,
    handleChangeChecklistBuatPo,
    handleBuatPo,
    listItemChecklist,
    vendorPick,
    setVendorPick,
    tglPoPick,
    setTglPoPick,
    deliveryTime,
    setDeliveryTime,
    termOfPayment,
    setTermOfPayment,
    keteranganPo,
    setKeteranganPo,
    handleChangeBuatPo,
    subMenu,
    setSubMenu,
    listVendor,
    popUpNewPo,
    setPopUpNewPo,
    newJumlah,
    setNewJumlah,
    newSatuan,
    setNewSatuan,
    isBarangSudahAda,
    setIsBarangSudahAda,
    dataListNama,
    mergeArray,
    removeFields,
    addFields,
    subTitleNewPo,
    handleChangeSubtitle,
    produkNewPo,
    setProdukNewPo,
    handleChangeKirimNewPo,
    isDisabled,
    setIsDisabled,
    keteranganNewPo,
    setKeteranganNewPo,
    checklistPpn,
    setChecklistPpn,
    handleKirimBuatPo,
    search,
    setSearch,
    handleSearch,
    searchData,
    lastData,
    listPoPurchasing,
    popUpDetail,
    setPopUpDetail,
    pickDataDetail,
    setPickDataDetail,
    dataPerusahaan,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    overallDiscount,
    setOverallDiscount,
    popUpDetailPo,
    setPopUpDetailPo,
    handleDelete,
    setIsRefresh,
    handleCloseNewPo,
    popUpCariPo,
    setPopUpCariPo,
    filterBulanDari,
    setFilterBulanDari,
    filterTahunDari,
    setFilterTahunDari,
    filterBulanSampai,
    setFilterBulanSampai,
    filterTahunSampai,
    setFilterTahunSampai,
    itemCari,
    setItemCari,
    listCariData,
    setListCariData,
    handleExportCariBarang,
    popUpEditOpen,
    setPopUpEditOpen,
    popUpEditPo,
    setPopUpEditPo,
    handleChangeEdit,
    handleChangeProdukEditPo,
    handleChangeSubtitleEditPo,
    addFieldsEditPo,
    removeFieldsEditPo,
    editDataPo,
    setEditDataPo,
    handleEditPo,
    editPoHeader,
    setEditPoHeader,
    editPoData,
    setEditPoData,
    handleChangeEditPo,
    handleSubmitEditPo,
    handleChangeHeaderEditPo,
  } = usePurchaseOrder();

  const customStyles = {
    option: (provided) => ({
      ...provided,
      color: "black",
    }),
    control: (provided) => ({
      ...provided,
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const selectedVendor = listVendor?.find((v) => v.id === vendorPick?.id);

  const sumSubtotal =
    listItemChecklist &&
    listItemChecklist.reduce((total, item) => {
      return total + (item.jumlah || 0) * (item.price || 0);
    }, 0);

  const sumDiscount =
    listItemChecklist &&
    listItemChecklist.reduce((total, item) => {
      return (
        total + (item.discount * (item.price * Number(item.jumlah))) / 100 || 0
      );
    }, 0);

  const checkDiscount =
    sumDiscount > 0 ? sumDiscount : overallDiscount > 0 ? overallDiscount : 0;

  const checkDataLengthChecklist = searchData?.filter(
    (item) => item.isBuatPo === true
  );

  const tax = checklistPpn ? ((sumSubtotal - checkDiscount) * 11) / 100 : 0;

  const netto = sumSubtotal - checkDiscount;
  const sumTotal = sumSubtotal - checkDiscount + tax;

  const curr = listItemChecklist?.[0]?.curr;

  const qtyItemDetail = pickDataDetail?.jumlah || 0;
  const priceItemDetail = pickDataDetail?.price || 0;
  const calculateDiscount =
    (pickDataDetail?.discount *
      (pickDataDetail?.price * pickDataDetail?.jumlah)) /
    100;
  const discountDetail = pickDataDetail?.discount
    ? calculateDiscount
    : overallDiscount > 0
    ? overallDiscount
    : "";

  const totalPricePerItemDetail =
    qtyItemDetail * priceItemDetail - discountDetail;

  const handleDownloadPdf = async (ele) => {
    const blob = await pdf(
      <PdfPurchaseOrder
        data={listPoPurchasing && listPoPurchasing}
        noPo={ele.noPo}
        formId={ele?.formId || ""}
        listVendor={listVendor && listVendor}
        dataPerusahaan={dataPerusahaan && dataPerusahaan}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${ele?.noPo || "document"}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const selectedVendorDetail =
    listVendor &&
    listVendor.find((v) => v.id === pickDataDetail?.vendorId || "");

  const selectedNoPo =
    listPoPurchasing?.filter((v) => v.noPo === pickDataDetail?.noPo) || [];

  const resolvedVendorPo =
    typeof pickDataDetail?.vendorId === "object" &&
    pickDataDetail?.vendorId !== null
      ? pickDataDetail.vendorId
      : listVendor?.find((v) => v.id === pickDataDetail?.vendorId) || {};

  const sumSubtotalDetailPo =
    selectedNoPo &&
    selectedNoPo.reduce((total, item) => {
      return total + (item.jumlah || 0) * (item.price || 0);
    }, 0);

  const sumDiscountDetailPo =
    selectedNoPo &&
    selectedNoPo.reduce((total, item) => {
      return (
        total + (item.discount * (item.price * Number(item.jumlah))) / 100 || 0
      );
    }, 0);

  const checkDiscountDetailPo =
    sumDiscountDetailPo > 0
      ? sumDiscountDetailPo
      : selectedNoPo[0]?.overallDiscount > 0
      ? selectedNoPo[0].overallDiscount
      : 0;

  const taxDetailPo = selectedNoPo[0]?.checklistPpn
    ? ((sumSubtotalDetailPo - checkDiscountDetailPo) * 11) / 100
    : 0;

  const nettoDetailPo = sumSubtotalDetailPo - checkDiscountDetailPo;
  const sumTotalDetailPo =
    sumSubtotalDetailPo - checkDiscountDetailPo + taxDetailPo;

  console.log(popUpDetailPo);
  return (
    <div>
      {dataUser !== null ? <MenuComponent setMenu={setMenu} menu={menu} /> : ""}
      {popUpNewPo ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "50%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              className="checkbox-bpb"
              onClick={() =>
                isBarangSudahAda
                  ? setIsBarangSudahAda(false)
                  : setIsBarangSudahAda(true)
              }
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                checked={isBarangSudahAda}
              />
              <label>Nama Barang sudah ada</label>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPopUpNewPo(false);
                handleCloseNewPo();
              }}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            <div style={{ minWidth: "64%" }}>
              <p style={{ margin: "6px 0" }}>Item :</p>
              {isBarangSudahAda ? (
                <Select
                  styles={customStyles}
                  options={mergeArray && mergeArray}
                  value={produkNewPo || ""}
                  onChange={setProdukNewPo}
                />
              ) : (
                <input
                  type="text"
                  style={{ height: "31px", width: "98%" }}
                  value={produkNewPo || ""}
                  onChange={(e) => setProdukNewPo(e.target.value.toUpperCase())}
                />
              )}
            </div>
            <div>
              <p style={{ margin: "6px 0" }}>Jumlah :</p>
              <input
                type="text"
                style={{ height: "31px", width: "64px" }}
                value={newJumlah ? formatDot(Number(newJumlah)) : ""}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\./g, "");
                  setNewJumlah(raw);
                }}
              />
            </div>
            <div>
              <p style={{ margin: "6px 0" }}>Satuan :</p>
              <select
                value={newSatuan}
                onChange={(e) => setNewSatuan(e.target.value)}
                style={{ height: "37px" }}
              >
                <option>Pilih Satuan</option>
                {dataListNama &&
                  dataListNama.listSatuan.map((ele) => (
                    <option value={ele.value}>{ele.label}</option>
                  ))}
              </select>
            </div>
          </div>
          <p style={{ margin: "6px 0" }}>Sub Title :</p>
          <div className="container-input-new-po-subtitle">
            <div className="wrapper-input-new-po-subtitle">
              {subTitleNewPo.map((ele, index) => (
                <div style={{ display: "flex", gap: "16px" }}>
                  <input
                    type="text"
                    style={{ height: "22px", width: "100%" }}
                    name="desc"
                    value={ele?.desc || ""}
                    placeholder="Deskripsi"
                    onChange={(e) => handleChangeSubtitle(index, e)}
                  />
                  <input
                    type="text"
                    style={{ height: "22px", width: "84px" }}
                    name="qty"
                    placeholder="Qty (2 UNIT)"
                    value={ele?.qty || ""}
                    onChange={(e) => handleChangeSubtitle(index, e)}
                  />
                </div>
              ))}
            </div>

            <div style={{ display: "flex", alignItems: "end" }}>
              <button
                className="button_plus"
                style={{ marginRight: "16px" }}
                onClick={() => removeFields()}
              >
                &#8722;
              </button>
              <button className="button_plus" onClick={() => addFields(true)}>
                &#43;
              </button>
            </div>
          </div>
          <br />
          <p style={{ margin: "6px 0" }}>Keterangan :</p>
          <textarea
            style={{ width: "63%", height: "72px", resize: "none" }}
            value={keteranganNewPo}
            onChange={(e) => setKeteranganNewPo(e.target.value.toUpperCase())}
          />
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="button-create-po"
              disabled={isDisabled}
              style={isDisabled ? { background: "gray" } : {}}
              onClick={() => {
                setIsDisabled(true);
                handleChangeKirimNewPo();
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpBuatPo ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90vh",
            width: "88%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <p>Nama Penyedia Eksternal :</p>
              <div style={{ minWidth: "280px" }}>
                <Select
                  styles={customStyles}
                  options={listVendor && listVendor}
                  value={vendorPick || ""}
                  onChange={setVendorPick}
                />
              </div>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => handleCloseBuatPo()}
              alt="edit_logo"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "70%" }}>
              <div style={{ display: "flex" }}>
                <p style={{ margin: "6px 0", width: "130px" }}>Alamat</p>
                <p style={{ margin: "6px 0", width: "12px" }}>:</p>
                <p
                  style={{
                    margin: "6px 0",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {selectedVendor?.alamat || ""}
                </p>
              </div>

              <div style={{ display: "flex" }}>
                <p style={{ margin: "6px 0", width: "130px" }}>
                  Tlp / Fax / Email
                </p>
                <p style={{ margin: "6px 0", width: "12px" }}>:</p>
                <p
                  style={{
                    margin: "6px 0",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {selectedVendor?.tlp}
                  {selectedVendor?.fax ? ` / ${selectedVendor.fax}` : ""}
                  {selectedVendor?.email ? ` / ${selectedVendor.email}` : ""}
                </p>
              </div>

              <div style={{ display: "flex" }}>
                <p style={{ margin: "6px 0", width: "130px" }}>Attn</p>
                <p style={{ margin: "6px 0", width: "12px" }}>:</p>
                <p style={{ margin: "6px 0", flex: 1 }}>
                  {selectedVendor?.attn || ""}
                </p>
              </div>
            </div>

            <div style={{ width: "25%" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px" }}>Tgl PO :</p>
                <input
                  type="date"
                  style={{ height: "24px" }}
                  value={tglPoPick}
                  onChange={(e) => setTglPoPick(e.target.value)}
                />
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px" }}>No PO :</p>
                <p style={{ margin: "6px 0px", letterSpacing: "1px" }}>
                  {lastData?.lastNoPo || ""}
                </p>
              </div>
            </div>
          </div>

          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>
                <th className="th-po">Description</th>
                <th
                  className="th-po"
                  style={{
                    textAlign: "center",
                  }}
                >
                  Quantity
                </th>
                <th className="th-po">Curr</th>
                <th className="th-po">Unit Price</th>
                <th className="th-po">Discount</th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderLeft: "1px solid lightgray",
                  }}
                >
                  Total Price
                </th>
              </tr>
              {listItemChecklist &&
                listItemChecklist.map((ele, index) => {
                  const qtyItem = ele?.jumlah || 0;
                  const priceItem = ele?.price || 0;
                  const totalPricePerItem = qtyItem * priceItem;

                  const lastPrice =
                    lastData?.lastPrice.find((item) => item.id === ele.id)
                      ?.lastPrice || 0;
                  const lastCurr =
                    lastData?.lastPrice.find((item) => item.id === ele.id)
                      ?.lastCurr || "";
                  const lastDiscount =
                    lastData?.lastPrice.find((item) => item.id === ele.id)
                      ?.lastDiscount || "";

                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white" }
                          : { background: "#F7F7F7" }
                      }
                    >
                      <td
                        className="td-no-po"
                        style={
                          ele.subTitle
                            ? {
                                padding: "17px 0",
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {index + 1}.
                      </td>
                      <td className="td-item-potd-item-po">
                        {ele.item}
                        {ele.subTitle ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.desc}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        {ele.keterangan ? <>{ele.keterangan}</> : ""}
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        <input
                          type="text"
                          value={ele.jumlah ? formatDot(ele.jumlah) : ""}
                          onWheel={(e) => e.target.blur()}
                          className="input-qty-po"
                          name="jumlah"
                          placeholder="Qty"
                          onChange={(e) => handleChangeBuatPo(index, e, ele.id)}
                        />{" "}
                        {ele.satuan}
                        {ele.subTitle ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.qty}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        <select
                          style={{ height: "30px", cursor: "pointer" }}
                          value={ele.curr ? ele.curr : "IDR"}
                          name="curr"
                          onChange={(e) => handleChangeBuatPo(index, e, ele.id)}
                        >
                          <option disabled>Currency</option>
                          <option value="IDR">IDR</option>
                          <option value="USD">USD</option>
                        </select>
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        <input
                          type="text"
                          onWheel={(e) => e.target.blur()}
                          value={ele.price ? formatDot(ele.price) : ""}
                          name="price"
                          className="input-popup-discount"
                          placeholder={`${lastCurr ? lastCurr : "IDR"} ${
                            lastPrice ? formatDot(lastPrice) : ""
                          }`}
                          onChange={(e) => handleChangeBuatPo(index, e, ele.id)}
                        />
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        <input
                          type="text"
                          onWheel={(e) => e.target.blur()}
                          value={ele.discount ? formatDot(ele.discount) : ""}
                          name="discount"
                          className="input-popup-discount"
                          style={{ width: "30px", textAlign: "center" }}
                          placeholder={`${
                            lastDiscount ? formatDot(lastDiscount) : 0
                          } %`}
                          onChange={(e) => handleChangeBuatPo(index, e, ele.id)}
                        />{" "}
                        %
                      </td>
                      <td
                        style={
                          ele.subTitle
                            ? {
                                padding: "17px 6px 12px 6px",
                                verticalAlign: "top",
                                borderLeft: "1px solid lightgray",
                              }
                            : {
                                padding: "12px 6px 12px 6px",
                                borderLeft: "1px solid lightgray",
                              }
                        }
                      >
                        <b>{ele.curr ? `${ele.curr}` : "IDR"}</b>&nbsp;&nbsp;
                        {formatDot(totalPricePerItem)}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>

          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "12px 0" }}>Delivery Time :</p>
                <input
                  type="text"
                  style={{ height: "22px" }}
                  value={deliveryTime}
                  onChange={(e) =>
                    setDeliveryTime(e.target.value.toUpperCase())
                  }
                />
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "12px 0" }}>Term of Payment :</p>
                <input
                  type="text"
                  style={{ height: "22px" }}
                  value={termOfPayment}
                  onChange={(e) =>
                    setTermOfPayment(e.target.value.toUpperCase())
                  }
                />
              </div>
            </div>

            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p
                  style={{
                    margin: "6px 0",
                  }}
                >
                  Sub Total :
                </p>
                <p
                  style={{
                    margin: "6px 0",
                  }}
                >
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(sumSubtotal)}
                </p>
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "6px 0" }}>Discount :</p>
                <div>
                  <b>{curr || "IDR"}</b>&nbsp;{" "}
                  {sumDiscount > 0 ? (
                    formatDot(sumDiscount)
                  ) : (
                    <input
                      type="text"
                      style={{ width: "96px" }}
                      value={overallDiscount ? formatDot(overallDiscount) : ""}
                      onWheel={(e) => e.target.blur()}
                      className="input-qty-po"
                      name="jumlah"
                      placeholder="0"
                      onChange={(e) => {
                        const raw = e.target.value.replace(/\./g, "");
                        setOverallDiscount(raw);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "6px 0" }}>Netto :</p>
                <div>
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(netto)}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p
                  style={{
                    margin: "6px 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Tax :
                  <input
                    type="checkbox"
                    value={checklistPpn}
                    onChange={(e) => {
                      if (checklistPpn === true) {
                        setChecklistPpn(false);
                      } else if (checklistPpn === false) {
                        setChecklistPpn(true);
                      }
                    }}
                    style={{
                      marginLeft: "6px",
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                    }}
                  />
                </p>
                <div>
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(tax)}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p className="p-total-perhitungan">Total :</p>
                <div className="p-hasil-total-perhitungan">
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(sumTotal)}
                </div>
              </div>
            </div>
          </div>

          <p style={{ margin: "6px 0" }}>Notes :</p>
          <textarea
            style={{ width: "40%", height: "72px", resize: "none" }}
            value={keteranganPo}
            onChange={(e) => setKeteranganPo(e.target.value.toUpperCase())}
          />
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="button-create-po"
              disabled={isDisabled}
              style={isDisabled ? { background: "gray" } : {}}
              onClick={() => {
                setIsDisabled(true);
                handleKirimBuatPo();
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDetail ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "65%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <p style={{ fontWeight: "bold" }}>Nama Penyedia Eksternal :</p>
              <p>{selectedVendorDetail?.name || ""}</p>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPickDataDetail();
                setPopUpDetail(false);
              }}
              alt="edit_logo"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "70%" }}>
              <div style={{ display: "flex", gap: "16px" }}>
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>
                  Alamat :
                </p>
                <p style={{ margin: "6px 0px", wordBreak: "break-word" }}>
                  {selectedVendorDetail?.alamat || ""}
                </p>
              </div>
              <div style={{ display: "flex", gap: "16px" }}>
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>
                  Tlp / Fax / Email :
                </p>
                <p style={{ margin: "6px 0px", wordBreak: "break-word" }}>
                  {selectedVendorDetail?.tlp}{" "}
                  {selectedVendorDetail?.fax
                    ? ` / ${selectedVendorDetail.fax}`
                    : ""}{" "}
                  {selectedVendorDetail?.email
                    ? ` / ${selectedVendorDetail.email}`
                    : ""}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>Attn :</p>
                <p style={{ margin: "6px 0px" }}>
                  {selectedVendorDetail?.attn}
                </p>
              </div>
            </div>

            <div style={{ width: "25%" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>
                  Tgl PO :
                </p>
                <p style={{ margin: "6px 0px" }}>
                  {pickDataDetail?.datePo
                    ? moment(pickDataDetail?.datePo)
                        .utcOffset(7)
                        .format("DD/MM/YYYY")
                    : ""}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>No PO :</p>
                <p style={{ margin: "6px 0px", letterSpacing: "1px" }}>
                  {pickDataDetail?.noPo || ""}
                </p>
              </div>
            </div>
          </div>

          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>
                <th className="th-po">Description</th>
                <th
                  className="th-po"
                  style={{
                    textAlign: "center",
                  }}
                >
                  Quantity
                </th>
                <th className="th-po">Unit Price</th>
                <th className="th-po">Discount</th>
                <th className="th-po">Total Price</th>
              </tr>
              <tr style={{ background: "#F7F7F7" }}>
                <td
                  className="td-no-po"
                  style={
                    pickDataDetail.subTitle
                      ? {
                          padding: "17px 0",
                          verticalAlign: "top",
                          cursor: "pointer",
                        }
                      : {}
                  }
                >
                  1.
                </td>
                <td className="td-item-po">
                  {pickDataDetail.item}
                  {pickDataDetail.subTitle ? (
                    <>
                      {pickDataDetail.subTitle.map((obj) => (
                        <p style={{ color: "#878781", margin: "6px 0" }}>
                          {obj.desc}
                        </p>
                      ))}
                    </>
                  ) : (
                    ""
                  )}
                  {pickDataDetail.keterangan ? (
                    <>{pickDataDetail.keterangan}</>
                  ) : (
                    ""
                  )}
                </td>
                <td
                  className="td-po"
                  style={
                    pickDataDetail.subTitle
                      ? {
                          verticalAlign: "top",
                          textAlign: "center",
                        }
                      : { textAlign: "center" }
                  }
                >
                  {formatDot(pickDataDetail.jumlah)} {pickDataDetail.satuan}
                  {pickDataDetail.subTitle ? (
                    <>
                      {pickDataDetail.subTitle.map((obj) => (
                        <p style={{ color: "#878781", margin: "6px 0" }}>
                          {obj.qty}
                        </p>
                      ))}
                    </>
                  ) : (
                    ""
                  )}
                </td>
                <td
                  className="td-po"
                  style={
                    pickDataDetail.subTitle
                      ? {
                          verticalAlign: "top",
                        }
                      : {}
                  }
                >
                  {formatDot(pickDataDetail.price)}
                </td>
                <td
                  className="td-po"
                  style={
                    pickDataDetail.subTitle
                      ? {
                          verticalAlign: "top",
                        }
                      : {}
                  }
                >
                  {pickDataDetail?.discount
                    ? formatDot(pickDataDetail.discount)
                    : ""}{" "}
                  %
                </td>
                <td
                  className="td-po"
                  style={
                    pickDataDetail.subTitle
                      ? {
                          padding: "12px 6px 12px 6px",
                          verticalAlign: "top",
                          borderLeft: "1px solid lightgray",
                        }
                      : {}
                  }
                >
                  <b>
                    {pickDataDetail.curr ? `${pickDataDetail.curr}` : "IDR"}
                  </b>
                  &nbsp;&nbsp;
                  {formatDot(totalPricePerItemDetail)}
                </td>
              </tr>
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDetailPo ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "80%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <p style={{ fontWeight: "bold" }}>Nama Penyedia Eksternal :</p>
              <p>{resolvedVendorPo.name || ""}</p>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPickDataDetail();
                setPopUpDetailPo(false);
              }}
              alt="edit_logo"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "70%" }}>
              <div style={{ display: "flex" }}>
                <p
                  style={{
                    margin: "6px 0",
                    fontWeight: "bold",
                    width: "130px",
                  }}
                >
                  Alamat
                </p>
                <p style={{ margin: "6px 8px", width: "10px" }}>:</p>
                <p
                  style={{
                    margin: "6px 0",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {resolvedVendorPo.alamat || ""}
                </p>
              </div>

              <div style={{ display: "flex" }}>
                <p
                  style={{
                    margin: "6px 0",
                    fontWeight: "bold",
                    width: "130px",
                  }}
                >
                  Tlp / Fax / Email
                </p>
                <p style={{ margin: "6px 8px", width: "10px" }}>:</p>
                <p
                  style={{
                    margin: "6px 0",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {resolvedVendorPo.tlp}
                  {resolvedVendorPo.fax ? ` / ${resolvedVendorPo.fax}` : ""}
                  {resolvedVendorPo.email ? ` / ${resolvedVendorPo.email}` : ""}
                </p>
              </div>

              <div style={{ display: "flex" }}>
                <p
                  style={{
                    margin: "6px 0",
                    fontWeight: "bold",
                    width: "130px",
                  }}
                >
                  Attn
                </p>
                <p style={{ margin: "6px 8px", width: "10px" }}>:</p>
                <p style={{ margin: "6px 0", flex: 1 }}>
                  {resolvedVendorPo.attn || ""}
                </p>
              </div>
            </div>

            <div style={{ width: "25%" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>
                  Tgl PO :
                </p>
                <p style={{ margin: "6px 0px" }}>
                  {pickDataDetail?.datePo
                    ? moment(pickDataDetail?.datePo)
                        .utcOffset(7)
                        .format("DD/MM/YYYY")
                    : ""}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p style={{ margin: "6px 0px", fontWeight: "bold" }}>No PO :</p>
                <p style={{ margin: "6px 0px", letterSpacing: "1px" }}>
                  {pickDataDetail?.noPo || ""}
                </p>
              </div>
            </div>
          </div>

          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>
                <th className="th-po">Description</th>
                <th
                  className="th-po"
                  style={{
                    textAlign: "center",
                  }}
                >
                  Quantity
                </th>
                <th className="th-po">Unit Price</th>
                <th className="th-po">Discount</th>
                <th className="th-po">Total Price</th>
              </tr>
              {selectedNoPo &&
                selectedNoPo.map((obj, index) => {
                  const qtyItem = obj?.jumlah || 0;
                  const priceItem = obj?.price || 0;
                  const totalPricePerItem = qtyItem * priceItem;
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white" }
                          : { background: "#F7F7F7" }
                      }
                    >
                      <td
                        className="td-no-po"
                        style={
                          obj.subTitle
                            ? {
                                padding: "17px 0",
                                verticalAlign: "top",
                                cursor: "pointer",
                              }
                            : {}
                        }
                      >
                        {index + 1}.
                      </td>
                      <td className="td-item-po">
                        {obj.item}
                        {obj.subTitle ? (
                          <>
                            {obj.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.desc}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        {obj.keterangan ? <>{obj.keterangan}</> : ""}
                      </td>
                      <td
                        className="td-po"
                        style={
                          obj.subTitle
                            ? {
                                verticalAlign: "top",
                                textAlign: "center",
                              }
                            : { textAlign: "center" }
                        }
                      >
                        {formatDot(obj.jumlah)} {obj.satuan}
                        {obj.subTitle ? (
                          <>
                            {obj.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.qty}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      <td
                        className="td-po"
                        style={
                          obj.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {formatDot(obj.price)}
                      </td>
                      <td
                        className="td-po"
                        style={
                          obj.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {obj?.discount ? formatDot(obj.discount) : ""} %
                      </td>
                      <td
                        className="td-po"
                        style={
                          obj.subTitle
                            ? {
                                padding: "12px 6px 12px 6px",
                                verticalAlign: "top",
                                borderLeft: "1px solid lightgray",
                              }
                            : {}
                        }
                      >
                        <b>{obj.curr ? `${obj.curr}` : "IDR"}</b>
                        &nbsp;&nbsp;
                        {formatDot(totalPricePerItem)}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "12px 0" }}>Delivery Time :</p>
                {selectedNoPo[0]?.deliveryTime || ""}
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "12px 0" }}>Term of Payment :</p>
                <p style={{ margin: "12px 0" }}>
                  {selectedNoPo[0]?.termOfPayment || ""}
                </p>
              </div>
            </div>

            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <p
                  style={{
                    margin: "6px 0",
                  }}
                >
                  Sub Total :
                </p>
                <p
                  style={{
                    margin: "6px 0",
                  }}
                >
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(sumSubtotalDetailPo)}
                </p>
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "6px 0" }}>Discount :</p>
                <div>
                  <b>{curr || "IDR"}</b>&nbsp;{" "}
                  {formatDot(checkDiscountDetailPo)}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "6px 0" }}>Netto :</p>
                <div>
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(nettoDetailPo)}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p style={{ margin: "6px 0" }}>Tax :</p>

                <div>
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(taxDetailPo)}
                </div>
              </div>
              <div className="wrapper-hasil-po">
                <p className="p-total-perhitungan">Total :</p>
                <div className="p-hasil-total-perhitungan">
                  <b>{curr || "IDR"}</b>&nbsp; {formatDot(sumTotalDetailPo)}
                </div>
              </div>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpCariPo ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "80%",
            overflowY: "scroll",
            padding: "12px",
            height: "90vh",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
                width: "90%",
              }}
            >
              <div style={{ width: "30%" }}>
                <p style={{ margin: "6px 0" }}>Nama Item</p>
                <Select
                  styles={customStyles}
                  options={mergeArray && mergeArray}
                  value={itemCari || ""}
                  onChange={setItemCari}
                />
              </div>
              <div>
                <p style={{ margin: "6px 0" }}>Dari</p>
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                  }}
                >
                  <select
                    style={{ height: "32px" }}
                    value={filterBulanDari}
                    onChange={(e) => setFilterBulanDari(e.target.value)}
                  >
                    <option>Bulan</option>
                    {bulan.map((obj) => (
                      <option value={obj.value}>{obj.name}</option>
                    ))}
                  </select>
                  <select
                    style={{ height: "32px" }}
                    value={filterTahunDari}
                    onChange={(e) => setFilterTahunDari(e.target.value)}
                  >
                    <option>Tahun</option>
                    {tahun.map((obj) => (
                      <option value={obj}>{obj}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <p style={{ margin: "6px 0" }}>Sampai</p>
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                  }}
                >
                  <select
                    style={{ height: "32px" }}
                    value={filterBulanSampai}
                    onChange={(e) => setFilterBulanSampai(e.target.value)}
                  >
                    <option>Bulan</option>
                    {bulan.map((obj) => (
                      <option value={obj.value}>{obj.name}</option>
                    ))}
                  </select>
                  <select
                    style={{ height: "32px" }}
                    value={filterTahunSampai}
                    onChange={(e) => setFilterTahunSampai(e.target.value)}
                  >
                    <option>Tahun</option>
                    {tahun.map((obj) => (
                      <option value={obj}>{obj}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "end" }}>
                <button
                  className="button-create-po"
                  style={{ backgroundColor: "green", margin: "6px 0" }}
                  onClick={() => {
                    handleExportCariBarang();
                  }}
                >
                  Export
                </button>
              </div>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setFilterBulanDari(moment().utcOffset("+0700").month() + 1);
                setFilterTahunDari(moment().utcOffset("+0700").year());
                setFilterBulanSampai(moment().utcOffset("+0700").month() + 1);
                setFilterTahunSampai(moment().utcOffset("+0700").year());
                setItemCari();
                setListCariData();
                setPopUpCariPo(false);
              }}
              alt="edit_logo"
            />
          </div>
          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>
                <th className="th-po">PO</th>
                <th className="th-po">Tgl PO</th>
                <th className="th-po">Item</th>
                <th
                  className="th-po"
                  style={{
                    textAlign: "center",
                  }}
                >
                  Quantity
                </th>
                <th className="th-po">Unit Price</th>
                <th className="th-po">Discount</th>
              </tr>
              {listCariData &&
                listCariData.map((ele, index) => {
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white" }
                          : { background: "#F7F7F7" }
                      }
                    >
                      <td
                        className="td-no-po"
                        style={
                          ele.subTitle
                            ? {
                                padding: "17px 0",
                                verticalAlign: "top",
                                cursor: "pointer",
                              }
                            : {}
                        }
                      >
                        {index + 1}.
                      </td>
                      <td
                        className="td-item-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {ele.noPo}
                      </td>
                      <td
                        className="td-item-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {moment(ele.datePo).utcOffset(7).format("DD-MM-YYYY")}
                      </td>
                      <td className="td-item-po">
                        {ele.item}
                        {ele.subTitle ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.desc}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        {ele.keterangan ? <>{ele.keterangan}</> : ""}
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                                textAlign: "center",
                              }
                            : { textAlign: "center" }
                        }
                      >
                        {formatDot(ele.jumlah)} {ele.satuan}
                        {ele.subTitle ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.qty}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        <b>{ele.curr ? `${ele.curr}` : "IDR"}</b>{" "}
                        {formatDot(ele.price)}
                      </td>
                      <td
                        className="td-po"
                        style={
                          ele.subTitle
                            ? {
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {ele?.discount ? formatDot(ele.discount) : ""} %
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpEditOpen ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "50%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPopUpEditOpen(false);
                setPickDataDetail();
              }}
              alt="edit_logo"
            />
          </div>

          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            <div style={{ minWidth: "64%" }}>
              <p style={{ margin: "6px 0" }}>Item :</p>

              <Select
                styles={customStyles}
                options={mergeArray && mergeArray}
                value={
                  mergeArray.find((v) => v.label === editDataPo.item) || null
                }
                onChange={handleChangeProdukEditPo}
              />
            </div>

            <div>
              <p style={{ margin: "6px 0" }}>Jumlah :</p>

              <input
                type="text"
                name="jumlah"
                style={{ height: "31px", width: "64px" }}
                value={
                  editDataPo.jumlah ? formatDot(Number(editDataPo.jumlah)) : ""
                }
                onChange={(e) => {
                  const raw = e.target.value.replace(/\./g, "");

                  setEditDataPo((prev) => ({
                    ...prev,
                    jumlah: raw,
                  }));
                }}
              />
            </div>

            <div>
              <p style={{ margin: "6px 0" }}>Satuan :</p>

              <select
                name="satuan"
                value={editDataPo.satuan}
                onChange={handleChangeEdit}
                style={{ height: "37px" }}
              >
                <option>Pilih Satuan</option>

                {dataListNama &&
                  dataListNama.listSatuan.map((ele) => (
                    <option value={ele.value}>{ele.label}</option>
                  ))}
              </select>
            </div>
          </div>

          <p style={{ margin: "6px 0" }}>Sub Title :</p>

          <div className="container-input-new-po-subtitle">
            <div className="wrapper-input-new-po-subtitle">
              {editDataPo.subTitle.map((ele, index) => (
                <div key={index} style={{ display: "flex", gap: "16px" }}>
                  <input
                    type="text"
                    style={{ height: "22px", width: "100%" }}
                    name="desc"
                    value={ele?.desc || ""}
                    placeholder="Deskripsi"
                    onChange={(e) => handleChangeSubtitleEditPo(index, e)}
                  />

                  <input
                    type="text"
                    style={{ height: "22px", width: "84px" }}
                    name="qty"
                    placeholder="Qty (2 UNIT)"
                    value={ele?.qty || ""}
                    onChange={(e) => handleChangeSubtitleEditPo(index, e)}
                  />
                </div>
              ))}
            </div>

            <div style={{ display: "flex", alignItems: "end" }}>
              <button
                className="button_plus"
                style={{ marginRight: "16px" }}
                onClick={removeFieldsEditPo}
              >
                &#8722;
              </button>

              <button className="button_plus" onClick={addFieldsEditPo}>
                &#43;
              </button>
            </div>
          </div>

          <br />

          <p style={{ margin: "6px 0" }}>Keterangan :</p>

          <textarea
            name="keterangan"
            style={{
              width: "63%",
              height: "72px",
              resize: "none",
            }}
            value={editDataPo.keterangan}
            onChange={handleChangeEdit}
          />

          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="button-create-po"
              disabled={isDisabled}
              style={isDisabled ? { background: "gray" } : {}}
              onClick={() => handleEditPo("Open")}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpEditPo ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90vh",
            width: "88%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <p>Nama Penyedia Eksternal :</p>
              <Select
                styles={customStyles}
                options={listVendor || []}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                value={
                  listVendor?.find(
                    (vendor) => vendor.id === editPoHeader.vendorId
                  ) || null
                }
                onChange={(selected) => {
                  setEditPoHeader((prev) => ({
                    ...prev,
                    vendorId: selected?.id || "",
                    vendor: selected?.name || "",
                  }));
                }}
                placeholder="Pilih Vendor"
              />
            </div>

            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPopUpEditPo(false);
                setPickDataDetail();
                setEditPoData([]);
              }}
              alt="edit_logo"
            />
          </div>

          <br />

          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{
                width: "100%",
                borderSpacing: 0,
              }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>

                <th className="th-po">Description</th>

                <th className="th-po">Quantity</th>

                <th className="th-po">Curr</th>

                <th className="th-po">Unit Price</th>

                <th className="th-po">Discount</th>

                <th className="th-po">Total</th>
              </tr>

              {editPoData?.map((ele, index) => {
                const total = Number(ele.jumlah || 0) * Number(ele.price || 0);

                return (
                  <tr
                    style={
                      index % 2 === 0
                        ? {
                            background: "white",
                          }
                        : {
                            background: "#F7F7F7",
                          }
                    }
                  >
                    <td className="td-no-po">{index + 1}.</td>

                    <td className="td-item-potd-item-po">
                      {ele.item}

                      {ele.subTitle?.map((obj) => (
                        <p
                          style={{
                            color: "#878781",
                            margin: "6px 0",
                          }}
                        >
                          {obj.desc}
                        </p>
                      ))}

                      {ele.keterangan ? <p>{ele.keterangan}</p> : ""}
                    </td>

                    <td className="td-po">
                      <input
                        type="text"
                        value={ele.jumlah ? formatDot(ele.jumlah) : ""}
                        className="input-qty-po"
                        name="jumlah"
                        onChange={(e) => handleChangeEditPo(index, e, ele.id)}
                      />{" "}
                      {ele.satuan}
                    </td>

                    <td className="td-po">
                      <select
                        name="curr"
                        value={ele.curr || "IDR"}
                        onChange={(e) => handleChangeEditPo(index, e, ele.id)}
                      >
                        <option value="IDR">IDR</option>

                        <option value="USD">USD</option>
                      </select>
                    </td>

                    <td className="td-po">
                      <input
                        type="text"
                        value={ele.price ? formatDot(ele.price) : ""}
                        name="price"
                        className="input-popup-discount"
                        onChange={(e) => handleChangeEditPo(index, e, ele.id)}
                      />
                    </td>

                    <td className="td-po">
                      <input
                        type="text"
                        value={ele.discount ? formatDot(ele.discount) : ""}
                        name="discount"
                        className="input-popup-discount"
                        style={{
                          width: "40px",
                        }}
                        onChange={(e) => handleChangeEditPo(index, e, ele.id)}
                      />{" "}
                      %
                    </td>

                    <td className="td-po">
                      <b>{ele.curr || "IDR"}</b> {formatDot(total)}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>

          <br />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div className="wrapper-hasil-po">
                <p>Delivery Time :</p>

                <input
                  type="text"
                  name="deliveryTime"
                  value={editPoHeader.deliveryTime}
                  onChange={handleChangeHeaderEditPo}
                />
              </div>

              <div className="wrapper-hasil-po">
                <p>Term Of Payment :</p>

                <input
                  type="text"
                  name="termOfPayment"
                  value={editPoHeader.termOfPayment}
                  onChange={handleChangeHeaderEditPo}
                />
              </div>
            </div>

            <div>
              <div className="wrapper-hasil-po">
                <p>Discount :</p>

                <input
                  type="text"
                  value={
                    editPoHeader.overallDiscount
                      ? formatDot(editPoHeader.overallDiscount)
                      : ""
                  }
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\./g, "");

                    setEditPoHeader((prev) => ({
                      ...prev,
                      overallDiscount: raw,
                    }));
                  }}
                />
              </div>
            </div>
          </div>

          <p>Notes :</p>

          <textarea
            style={{
              width: "40%",
              height: "72px",
              resize: "none",
            }}
            name="keteranganPo"
            value={editPoHeader.keteranganPo}
            onChange={handleChangeHeaderEditPo}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <button
              className="button-create-po"
              disabled={isDisabled}
              style={isDisabled ? { background: "gray" } : {}}
              onClick={() => handleSubmitEditPo("PO")}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="container-inventory">
        <div className="wrapper-inventory">
          <div className="wrapper_sub_menu_bpb">
            <p
              className={
                subMenu === "Open"
                  ? "sub_menu_bpb border_active_bpb"
                  : "sub_menu_bpb"
              }
              onClick={() => setSubMenu("Open")}
            >
              Open
            </p>
            <p
              className={
                subMenu === "PO"
                  ? "sub_menu_bpb border_active_bpb"
                  : "sub_menu_bpb"
              }
              onClick={() => setSubMenu("PO")}
            >
              PO
            </p>
          </div>
          <div className="wrapper-filter-po">
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                className="search_box_inventory"
                style={{ marginRight: "0" }}
                type="text"
                placeholder="Cari Purchase Order"
                value={search || ""}
                onChange={(e) => {
                  setSearch(e.target.value);
                  handleSearch(e.target.value);
                }}
              />
              {subMenu !== "Open" ? (
                <div style={{ display: "flex", gap: "8px" }}>
                  <select
                    style={{ height: "32px" }}
                    value={filterBulan}
                    onChange={(e) => setFilterBulan(e.target.value)}
                  >
                    <option>Bulan</option>
                    {bulan.map((obj) => (
                      <option value={obj.value}>{obj.name}</option>
                    ))}
                  </select>
                  <select
                    style={{ height: "32px" }}
                    value={filterTahun}
                    onChange={(e) => setFilterTahun(e.target.value)}
                  >
                    <option>Tahun</option>
                    {tahun.map((obj) => (
                      <option value={obj}>{obj}</option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}
              <p
                className="btn_reset_search_inventory"
                style={{ margin: "0 0px 12px 0" }}
                onClick={() => {
                  setSearch();
                  handleSearch();
                  setFilterBulan(moment().utcOffset("+0700").month() + 1);
                  setFilterTahun(moment().utcOffset("+0700").year());
                }}
              >
                Reset
              </p>
              <img
                src={RefreshIcon}
                alt="refresh"
                className="img-refresh-po"
                onClick={() => setIsRefresh(true)}
              />
              <button
                className="button-create-po"
                style={{ background: "#fe8c50" }}
                onClick={() => setPopUpCariPo(true)}
              >
                Cari Barang
              </button>
              {checkDataLengthChecklist?.length > 0 ? (
                <button
                  className="button-create-po"
                  onClick={() => handleBuatPo()}
                >
                  Buat PO
                </button>
              ) : (
                ""
              )}
            </div>
            <button
              className="button-create-po"
              style={{ backgroundColor: "green" }}
              onClick={() => {
                setPopUpNewPo(true);
              }}
            >
              + New Item
            </button>
          </div>
          <div className="wrapper-table-po">
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th className="td-no-item-po">No.</th>
                {subMenu === "PO" ? (
                  <>
                    <th className="th-po-border-left">Vendor</th>
                    <th className="th-po-border-left">PO</th>
                    <th className="th-po-border-left"></th>
                  </>
                ) : (
                  ""
                )}
                <th className="th-po-border-left">Item</th>
                {subMenu === "Open" ? (
                  <th
                    style={{
                      padding: "12px 6px 12px 6px",
                      textAlign: "center",
                      borderLeft: "1px solid lightgray",
                    }}
                  >
                    Buat PO
                  </th>
                ) : (
                  ""
                )}
                <th className="th-po-border-left">Qty</th>
                {subMenu === "PO" ? (
                  <>
                    <th className="th-po-border-left">Price</th>
                    <th className="th-po-border-left">Discount</th>
                    <th className="th-po-border-left">Sub Total</th>
                    <th className="th-po-border-left">Tgl PO</th>
                  </>
                ) : (
                  ""
                )}
                <th className="th-po-border-left"></th>
                <th className="th-po-border-left"></th>
              </tr>
              {searchData &&
                searchData.map((ele, index) => {
                  const qtyItem = ele?.jumlah || 0;
                  const priceItem = ele?.price || 0;
                  const discount = ele?.discount || 0;
                  const totalPricePerItem =
                    qtyItem * priceItem * (1 - discount / 100);
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white" }
                          : { background: "#F7F7F7" }
                      }
                    >
                      <td
                        className="td-no-po"
                        style={
                          ele.subTitle && subMenu !== "PO"
                            ? {
                                verticalAlign: "top",
                              }
                            : { cursor: "pointer" }
                        }
                        onClick={() => {
                          if (subMenu === "PO") {
                            setPopUpDetail(true);
                            setPickDataDetail(ele);
                          }
                        }}
                      >
                        {index + 1}.
                      </td>
                      {subMenu === "PO" ? (
                        <>
                          <td
                            className="td-item-po-border-left"
                            style={
                              ele.subTitle && subMenu !== "PO"
                                ? {
                                    padding: "16px 6px 12px 6px",
                                    verticalAlign: "top",
                                  }
                                : {}
                            }
                          >
                            {ele.vendor}
                          </td>
                          <td
                            className="td-po"
                            style={
                              ele.subTitle
                                ? {
                                    verticalAlign: "top",
                                    cursor: "pointer",
                                  }
                                : { cursor: "pointer" }
                            }
                            onClick={() => {
                              if (subMenu === "PO") {
                                console.log(ele);
                                setPopUpDetailPo(true);
                                setPickDataDetail(ele);
                              }
                            }}
                          >
                            {ele?.noPo}
                          </td>
                          <td className="wrapper-pdf-icon">
                            <img
                              src={PdfLogo}
                              className="pdf-icon"
                              onClick={() => handleDownloadPdf(ele)}
                            />
                          </td>
                        </>
                      ) : (
                        ""
                      )}
                      <td
                        className="td-item-po-border-left"
                        style={
                          subMenu === "PO"
                            ? {
                                cursor: "pointer",
                              }
                            : {}
                        }
                        onClick={() => {
                          if (subMenu === "PO") {
                            setPopUpDetail(true);
                            setPickDataDetail(ele);
                          }
                        }}
                      >
                        {ele.item}
                        {ele.subTitle && subMenu !== "PO" ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.desc}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}{" "}
                        {ele.keterangan ? <>{ele.keterangan}</> : ""}
                      </td>
                      {subMenu === "Open" ? (
                        <td className="td-checkbox-buat-po">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              className="checkbox-buat-po"
                              name="isBuatPo"
                              checked={ele?.isBuatPo || false}
                              onChange={(e) =>
                                handleChangeChecklistBuatPo(
                                  index,
                                  e,
                                  ele.formId
                                )
                              }
                            />
                          </div>
                        </td>
                      ) : (
                        ""
                      )}
                      <td
                        className="td-item-po-border-left"
                        style={
                          ele.subTitle && subMenu !== "PO"
                            ? {
                                padding: "16px 6px 12px 6px",
                                verticalAlign: "top",
                              }
                            : {}
                        }
                      >
                        {ele.jumlah} {ele.satuan}
                        {ele.subTitle && subMenu !== "PO" ? (
                          <>
                            {ele.subTitle.map((obj) => (
                              <p style={{ color: "#878781", margin: "6px 0" }}>
                                {obj.qty}
                              </p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                      {subMenu === "PO" ? (
                        <>
                          <td
                            style={
                              ele.subTitle
                                ? {
                                    verticalAlign: "top",
                                  }
                                : {}
                            }
                            className="td-po"
                          >
                            <b>{ele?.curr || "IDR"}</b>&nbsp;
                            {formatDot(priceItem)}
                          </td>
                          <td
                            className="td-po"
                            style={
                              ele.subTitle
                                ? {
                                    verticalAlign: "top",
                                  }
                                : {}
                            }
                          >
                            {formatDot(discount)}&nbsp;%
                          </td>
                          <td
                            className="td-po"
                            style={
                              ele.subTitle
                                ? {
                                    verticalAlign: "top",
                                  }
                                : {}
                            }
                          >
                            <b>{ele?.curr || "IDR"}</b>&nbsp;
                            {formatDot(totalPricePerItem)}
                          </td>
                          <td
                            className="td-po"
                            style={
                              ele.subTitle
                                ? {
                                    verticalAlign: "top",
                                  }
                                : {}
                            }
                          >
                            {ele.datePo
                              ? moment(ele.datePo)
                                  .utcOffset("+0700")
                                  .format("DD-MM-YYYY")
                              : ""}
                          </td>
                        </>
                      ) : (
                        ""
                      )}
                      <td
                        className="wrapper-pdf-icon"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          className="img-delete-bpb"
                          style={{ background: "yellow" }}
                          src={EditLogo}
                          onClick={() => {
                            if (subMenu === "Open") {
                              setPopUpEditOpen(true);
                              setPickDataDetail(ele);
                            } else {
                              const selectedPo =
                                listPoPurchasing?.filter(
                                  (v) => v.noPo === ele.noPo
                                ) || [];

                              setPopUpEditPo(true);
                              setPickDataDetail(selectedPo);
                            }
                          }}
                        />
                      </td>
                      <td
                        className="wrapper-pdf-icon"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          className="img-delete-bpb"
                          src={DeleteIcon}
                          onClick={() => handleDelete(ele.formId)}
                        />
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PurchaseOrder;
